import { ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren, AfterViewInit, OnDestroy } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthorizePaymentType } from '../../constants/commonenums';
import { DynamicFormComponent } from '../../dynamicform/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../../dynamicform/models/common-models';
import { GuestService } from '../../services/guest.service';
import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'app-auth-refund-popup',
    templateUrl: './auth-refund-popup.component.html',
    styleUrls: ['./auth-refund-popup.component.scss'],
    standalone: false
})
export class AuthRefundPopupComponent implements OnInit, AfterViewInit, OnDestroy {


  subscriptions: Subscription = new Subscription();
  refundAmountConfig: FieldConfig[];
  _settings: any;
  OperationCurrency: string;
  refundOptions: any[] = [];
  @Input() data: any;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  AuthorizePaymentTypes = AuthorizePaymentType;
  message = '';
  constructor(public ps: PopupService, private cdf: ChangeDetectorRef, public gs: GuestService,  private ts: TranslateService) {

 }
  closeMessage() {
    this.message = '';
  }

  ngOnInit() {
    this.OperationCurrency = this.data.OperationCurrency;
    this.data.FinancialData.RefundOption.forEach(element => {
      element.LoyaltyAccountNumber = element.LoyaltyAccountNumber != "null" ? element.LoyaltyAccountNumber : null;
      let refundAmountConfig = [{
        type: 'input',
        name: 'refundAmountConfig',
        inputType: 'text',
        directive: 'appDecimalsOnly',
        appearance: true,
        isFormArray: false,
        value: this.data.FinancialData.RefundOption.length === 1 ? this.data.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) : 0,
        prefix: this.OperationCurrency,
        max: element?.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits),
        validation: [Validators.required, Validators.max(element?.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits))],
        disabled: this.data.FinancialData.RefundOption.length > 1 ? true : false
      }];
      let data;
      data = { ...element };
      data.RoomNumber = data.RoomNumber != "null" ? data.RoomNumber : null;
      data.BucketName = data.BucketName != "null" ? data.BucketName : null;
      let checked = this.data.FinancialData.RefundOption.length === 1;
      this.refundOptions.push({ checked, data, refundAmountConfig })

    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.components.forEach((x, index) => {
        this.subscriptions.add(x.form.valueChanges.subscribe(value => {
          var formValid = true;
          this.components['_results'].forEach(({ form }, changeindex) => {
            if (this.refundOptions[changeindex].checked && form.status === "INVALID") {
              formValid = false;
            }
          });
          if (this.isTotalAmountMatching() && formValid) {
            this.ps.actiondisabled$.next(true);
            this.setRefundData();
	    this.message = "";
          } else {
            this.ps.actiondisabled$.next(false);
		if (this.isInputGreaterThanTotal()) {
              this.message = this.ts.instant("refundAmountGreaterMsg");
            }
          }
        }));
      });
      if (this.data.FinancialData.RefundOption.length === 1) {
        this.setRefundData();
        this.ps.actiondisabled$.next(true);
      } else {
        this.ps.actiondisabled$.next(false);
      }

    }, 100)
  }

  setRefundData() {
    this.gs.refundData = this.components['_results'].map((res, resIndex) => {
      return {
        AuthorizeTransactionID: this.data.FinancialData.RefundOption[resIndex].AuthorizeTransactionID,
        Amount: +res.form.controls[res.config[0].name].value
      }
    }).filter(itm => itm.Amount);
  }

  selectType(checked, index) {
    var form = this.components['_results'][index].form;
    if (checked) {
      form.enable();
      this.isTotalAmountMatching() ? this.ps.actiondisabled$.next(true) : this.ps.actiondisabled$.next(false);
    } else {
      form.controls.refundAmountConfig.setValue(0);
      form.disable();
    }
  }

  isTotalAmountMatching() {
    var total = 0;
    this.components['_results'].forEach(element => {
      total += +element.form.controls.refundAmountConfig.value;
    });
    return total.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) === this.data.FinancialData.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
  }

isInputGreaterThanTotal() {
    var total = 0;
    this.components['_results'].forEach(element => {
      total += +element.form.controls.refundAmountConfig.value;
    });
    return +total.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) > +this.data.FinancialData.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
  }
  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }
}
